import appendData from "common/utility";
import {
  del,
  get,
  getWithExportFile,
  post,
  postAsForm,
  put,
} from "helpers/api_helper";

export const getAllCategory = () => {
    return get("/product/getAllCategory");
  };

  export const createCategory = (data) => {
    return post("/product/createCategory", data);
  };

  
  export const deleteCategoryData = (data) => {
    return del("/product/deleteCategory", data);
  };
  export const deleteSubCategoryData = (data) => {
    return del("/product/deleteSubCategory", data);
  };

  export const createSubCategory = (data) => {
    return post("/product/createsubCategory", data);
  };
  